// @flow
import React from 'react';
import ContextMenuItem from '../util/ContextMenuItem';
import IconLabel from '../util/IconLabel';
import { defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  ariaButton: {
    id: 'aria-button-share',
    defaultMessage: 'Share',
  },
});

type OwnProps = {
  onClick: Function,
  text?: string,
  intl: IntlShape,
};

declare var __CAPACITOR__: boolean;

const ShareContextMenuItem = ({ onClick, text, intl }: OwnProps) => (
  <ContextMenuItem onClick={onClick}>
    <IconLabel
      name={__CAPACITOR__ ? 'share-android' : 'share'}
      size="default"
      labelVisible
      label={text || intl.formatMessage(messages.ariaButton)}
    />
  </ContextMenuItem>
);

export default injectIntl(ShareContextMenuItem);
